import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import queryString from "query-string";
import { withRouter } from "react-router-dom";
import { withCookies } from "react-cookie";
import DateRange from "../../Components/DateRange";
import BackendClient, { encodeBody } from "../../BackendClient";
import ApiClient from "../../Client";
import SummaryList from "./_list";
import { extendStyles } from "../../helpers/formComponent"

import Select from "react-select";
import { ValueContainer } from "../../Components/Select";
import DateFormat from "../../helpers/DateFormat";

const mapStateToProps = ({ identity }) => ({
  identity
});

class ReportsSummary extends Component {
  state = {
    cities: null,
    theatres: null,
    filters: {},
    reportGroup: [],
    isNoticeVisible: true
  };

  componentDidMount() {
    const { cities, theatres, reportGroup } = this.state;
    const { city, theatre, dateBegin, dateEnd } = queryString.parse(
      this.props.location.search,
      {
        decode: true,
        arrayFormat: "none"
      }
    );
    const queries = [];

    if (cities === null) {
      queries.push(this.fetchCities().then(cities => ({ cities })));
    }

    if (theatres === null) {
      queries.push(this.fetchTheatres().then(theatres => ({ theatres })));
    }

    if (!reportGroup.length || !dateEnd || !dateBegin || !city || !theatre) {
      let reportParams = this.getReportFilters();
      queries.push(
        BackendClient.getReports(reportParams)
          .fetchJson()
          .then(data => ({ reportGroup: data }))
      );
    }

    Promise.all(queries).then(results => {
      let data = results.reduce((prev, res) => Object.assign(prev, res));
      this.setState(data);
    });
  }

  componentDidUpdate() {
    let { filters: stateFilters } = this.state;
    const parsedFilters = {};
    const { city, theatre, dateBegin, dateEnd } = queryString.parse(
      this.props.location.search,
      {
        decode: true,
        arrayFormat: "none"
      }
    );

    if (city) {
      stateFilters.city !== city && Object.assign(parsedFilters, { city });
    } else if (stateFilters.city) {
      Object.assign(parsedFilters, { city: null });
    }

    if (theatre) {
      stateFilters.theatre !== theatre &&
        Object.assign(parsedFilters, { theatre });
    } else if (stateFilters.theatre) {
      Object.assign(parsedFilters, { theatre: null });
    }

    if (dateBegin) {
      if (
        !stateFilters.dateBegin ||
        stateFilters.dateBegin.ddmmyyyy() !== dateBegin
      ) {
        const dtBegin = this.strToDate(dateBegin);
        dtBegin && Object.assign(parsedFilters, { dateBegin: dtBegin });
      }
    } else if (stateFilters.dateBegin) {
      Object.assign(parsedFilters, { dateBegin: null });
    }

    if (dateEnd) {
      if (
        !stateFilters.dateEnd ||
        stateFilters.dateEnd.ddmmyyyy() !== dateEnd
      ) {
        const dtEnd = this.strToDate(dateEnd);
        dtEnd && Object.assign(parsedFilters, { dateEnd: dtEnd });
      }
    } else if (stateFilters.dateEnd) {
      Object.assign(parsedFilters, { dateEnd: null });
    }

    const hasNewFilters = !!Object.entries(parsedFilters).length;
    const filters = hasNewFilters
      ? Object.assign(stateFilters, parsedFilters)
      : stateFilters;

    if (hasNewFilters) {
      let reportParams = this.getReportFilters(filters);
      BackendClient.getReports(reportParams)
        .fetchJson()
        .then(reportGroup => this.setState({ reportGroup, filters }));
    }
  }

  strToDate = str => {
    let pattern = /(\d{2})\.(\d{2})\.(\d{4})/;
    return new Date(str.replace(pattern, "$3-$2-$1"));
  };

  getRange() {
    let {
      filters: { dateBegin, dateEnd }
    } = this.state;
    if (dateBegin && dateEnd) {
      return { dateBegin, dateEnd };
    }
    return {
      dateBegin: new Date(2018, 4, 1),
      dateEnd: new Date(2018, 4, 7)
    };
  }

  getDates() {
    const { dateBegin, dateEnd } = this.getRange();
    const range = [];
    range.push(dateBegin.getTime());
    range.push(dateEnd.getTime());
    return range;
  }

  getDateRanges = () => {
    let { dateBegin, dateEnd } = this.state.filters;

    if (!dateBegin || !dateEnd) {
      let range = this.getRange();
      dateBegin = range.dateBegin;
      dateEnd = range.dateEnd;
    }

    let dateArray = [];
    let currentDate = dateBegin;

    while (currentDate <= dateEnd) {
      dateArray.push({
        key: new Date(currentDate).ddmmyyyy(),
        value: new Date(currentDate).ddMM()
      });
      currentDate = currentDate.addDays(1);
    }
    return dateArray;
  };

  getReportFilters = filters => {
    let reportParams = {};
    let { dateBegin, dateEnd } = this.getRange();

    if (filters) {
      if (filters.dateBegin) {
        reportParams.dateBegin = filters.dateBegin.ddmmyyyy();
      }
      if (filters.dateEnd) {
        reportParams.dateEnd = filters.dateEnd.ddmmyyyy();
      }
      if (filters.city) {
        reportParams.city = filters.city;
      }
      if (filters.theatre) {
        reportParams.theatre = filters.theatre;
      }
    }

    if (!reportParams.dateBegin) {
      reportParams.dateBegin = dateBegin.ddmmyyyy();
    }
    if (!reportParams.dateEnd) {
      reportParams.dateEnd = dateEnd.ddmmyyyy();
    }

    return reportParams;
  };

  dateRangeFilterOnChange = ({ startDate, endDate }) => {
    this.updateLink({
      dateBegin: startDate.ddmmyyyy(),
      dateEnd: endDate.ddmmyyyy()
    });
  };

  getAuthCookie() {
    const { cookies } = this.props;
    return cookies.get(process.env.REACT_APP_IDENTITY_COOKIE) || "";
  }

  fetchCities() {
    const authKey = this.getAuthCookie();
    return ApiClient.setHeader("authKey", authKey)
      .request(`{cities{id name value:id label:name}}`)
      .then(({ cities }) => cities);
  }

  fetchTheatres() {
    const authKey = this.getAuthCookie();
    return ApiClient.setHeader("authKey", authKey)
      .request(`{theatres{id name value:id label:name}}`)
      .then(({ theatres }) => theatres);
  }

  cityFilterOnChange = cities => {
    let cityLink = "";

    if (cities.length) {
      let cityValues = [];

      cities.forEach((item, index) => {
        cityValues.push(item.value);
      });
      cityLink = cityValues.join(",");
    }
    this.updateLink({ city: cityLink || null });
  };

  theatreFilterOnChange = theatres => {
    let theatreLink = "";

    if (theatres.length) {
      let theatreValues = [];

      theatres.forEach((item, index) => {
        theatreValues.push(item.value);
      });
      theatreLink = theatreValues.join(",");
    }
    this.updateLink({ theatre: theatreLink || null });
  };

  getSelectedValues = (data, valuesAsString) => {
    let selectedOptions = [];

    if (data && data.length && valuesAsString) {
      let valuesAsArray = valuesAsString.split(",");
      data.forEach((item, itemIndex) => {
        valuesAsArray.forEach((filterItem, filterItemIndex) => {
          if (filterItem === item.value) {
            selectedOptions.push(item);
          }
        });
      });
    }

    return selectedOptions;
  };

  updateLink(newParams) {
    const {
      filters: { dateBegin, dateEnd, ...stateFitlers }
    } = this.state;
    const filters = Object.assign({}, stateFitlers);
    const params = Object.assign(filters, newParams);
    if (!params.dateBegin && dateBegin) {
      Object.assign(params, { dateBegin: DateFormat.ddmmyyyy(dateBegin) });
    }
    if (!params.dateEnd && dateEnd) {
      Object.assign(params, { dateEnd: DateFormat.ddmmyyyy(dateEnd) });
    }
    const body = Object.entries(params).reduce(
      (prev, [key, value]) =>
        (value && Object.assign(prev, { [key]: value })) || prev,
      {}
    );
    const stringParams = encodeBody(body, null, false);
    this.props.history.push(
      `reports-summary${stringParams && "?" + stringParams}`
    );
  }

  render() {
    const {
      cities,
      theatres,
      filters,
      reportGroup,
      isNoticeVisible
    } = this.state;
    const dateRange = this.getDateRanges();
    const dates = this.getDates();
    let topContent = "";
    if (!reportGroup.length && isNoticeVisible) {
      topContent = (
        <div className="notice-block">
          <div className="notice-block__icon">i</div>
          <div className="notice-block__description">
            Для просмотра сводки необходимо выбрать кинотеатр и даты.
            <br />
            При выборе города отобразится сводка по всем кинотеатрам в этом
            городе.
          </div>
          <button
            onClick={() => this.setState({ isNoticeVisible: false })}
            className="notice-block__hide"
          >
            Скрыть
          </button>
        </div>
      );
    }
    return (
      <Fragment>
        <h1 className="office-h1">Сводка по отчетам</h1>
        {topContent}
        <div className="office-filters">
          <div className="office-filters__half custom-datepicker__group">
            <label
              htmlFor="session-datepicker"
              className="custom-datepicker__label"
            >
              День начала/окончания
            </label>
            <DateRange
              input
              dateBegin={(dates[0] && new Date(dates[0])) || null}
              dateEnd={(dates[1] && new Date(dates[1])) || null}
              onChange={this.dateRangeFilterOnChange}
              className="custom-datepicker__input"
            />
            <img
              src="/images/icon-calendar.png"
              alt=""
              className="custom-datepicker__icon"
            />
          </div>

          <div className="office-filters__half custom-select__group">
            <Select
              components={{ ValueContainer }}
              onChange={this.cityFilterOnChange}
              options={this.state.cities || []}
              value={this.getSelectedValues(cities, filters.city)}
              className="selectReact"
              classNamePrefix="selectReact"
              isMulti={true}
              isClearable={true}
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              controlShouldRenderValue={true}
              moreThenOneText="Городов"
              placeholder="Начните вводить название города"
              styles={extendStyles(false)}
            />
          </div>
          <div className="office-filters__full">
            <Select
              components={{ ValueContainer }}
              onChange={this.theatreFilterOnChange}
              options={this.state.theatres || []}
              // value={this.returnDataForm("cinema")}
              value={this.getSelectedValues(theatres, filters.theatre)}
              className="selectReact"
              classNamePrefix="selectReact"
              isMulti={true}
              isClearable={true}
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              controlShouldRenderValue={true}
              moreThenOneText="Кинотеатров"
              placeholder="Начните вводить название кинотеатра"
              styles={extendStyles(false)}
            />
          </div>
        </div>
        <SummaryList reportGroup={reportGroup} dateRange={dateRange} />
      </Fragment>
    );
  }
}

export default withCookies(
  withRouter(connect(mapStateToProps)(ReportsSummary))
);



// WEBPACK FOOTER //
// ./src/containers/summary/admin.jsx